import { all } from "redux-saga/effects";
import waitForFetchProducts from "./saga";

export default function* rootSaga() {
    yield all([waitForFetchProducts()])
}